import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 24, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "0px 0px -40px 0px" }}
    transition={{ duration: 0.55, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const MaskedLine = ({ children, delay = 0, className = "" }) => (
  <span className={`block overflow-hidden ${className}`}>
    <motion.span
      className="block"
      initial={{ y: "112%" }}
      animate={{ y: 0 }}
      transition={{ duration: 0.8, delay, ease: EASE }}
    >
      {children}
    </motion.span>
  </span>
);

export const SectionHeading = ({ overline, title, sub, align = "left", id }) => (
  <div className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`}>
    <Reveal>
      <p className="text-xs font-bold uppercase tracking-[0.25em] text-brand-sky mb-4" data-testid={id ? `${id}-overline` : undefined}>{overline}</p>
    </Reveal>
    <Reveal delay={0.06}>
      <h2 className="font-display text-4xl md:text-5xl font-semibold tracking-tight text-slate-900 dark:text-white leading-[1.1]">{title}</h2>
    </Reveal>
    {sub && (
      <Reveal delay={0.12}>
        <p className="mt-5 text-base md:text-lg leading-relaxed text-slate-600 dark:text-slate-300">{sub}</p>
      </Reveal>
    )}
  </div>
);
